
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/swat-for-sale",
      function () {
        return require("private-next-pages/swat-for-sale/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/swat-for-sale"])
      });
    }
  